module.exports = __webpack_public_path__ + "img/n_bg2.cb2d9f55.jpg";